module.exports = __webpack_public_path__ + "img/sc-3p-2023-3.425cf631.png";